import { Dispatch, SetStateAction, useState } from 'react';

import { Button } from '../../../components/common/Button/Button';

import { Box, Flexed } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { Icon, IconWarningMark } from '../../../styles/Icons';
import { WithdrawStepsEnum } from './types';
import { P1, P2, P3 } from '../../../styles/FontStyles';
import { WithdrawWallet } from './WithdrawWallet';
import { flipmeNFTWithdraw } from '../../FlipMeWallet/FlipMeWallet.actions';
import { useDispatch } from 'react-redux';
import Spinner from '../../../components/common/Spinner';
import { useAppSelector } from '../../../app/hooks';

interface Step5Props {
  setWithdrawStep: Dispatch<SetStateAction<WithdrawStepsEnum>>;
  walletAddress: string | undefined;
  packageId: number;
  walletAddressSign: string;
  code: string;
  code2Fa: string;
  isConnected: boolean;
  connectWallet: () => Promise<void>;
  setWalletAddressSign: Dispatch<SetStateAction<string>>;
}

export const Step5 = ({
  setWithdrawStep,
  walletAddress,
  connectWallet,
  isConnected,
  setWalletAddressSign,
  packageId
}: Step5Props) => {
  const dispatch = useDispatch();
  const { loading } = useAppSelector((state) => state.wallets);
  const { verificationStatus } = useAppSelector((state) => state.settings);
  const { kycStatus } = useAppSelector((state) => state.auth.userInfo);

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <Box gray>
          <Flexed column center>
            <Flexed>
              <Icon mb='12'>
                <IconWarningMark color={color.colors.primary900} size='52' />
              </Icon>
            </Flexed>

            <P1 bold center mb='20'>
              FINAL STEP: CONFIRM THE WITHDRAWAL OF YOUR HUB NFT
            </P1>
            <P2 bold center mb='20' color={color.colors.error500}>
              IMPORTANT: DOUBLE CHECK YOUR ADDRESS
            </P2>

            <WithdrawWallet
              walletAddress={walletAddress}
              connectWallet={connectWallet}
              isButtonVisible={false}
              isConnected={isConnected}
              setWalletAddressSign={setWalletAddressSign}
            />

            <P3 bold center mb='20' mt='20' color={color.colors.error500}>
              Your withdrawal request is not reversible and the decision you
              make can not be changed later!
            </P3>

            <Button
              w='350px'
              mr='12'
              onClick={() => {
                if (isConnected) {
                  if (!verificationStatus) {
                    setWithdrawStep(WithdrawStepsEnum.TWO_FA_FACTOR_REQUIRED);
                  } else {
                    setWithdrawStep(WithdrawStepsEnum.SECURITY_VERIFICATION);
                  }
                } else {
                  dispatch(
                    flipmeNFTWithdraw({
                      userPackageId: packageId,
                      step: WithdrawStepsEnum.APPROVE_TRANSACTION_SUCCESS,
                      setStep: setWithdrawStep
                    })
                  );
                }
              }}>
              MAKE HUB NFT WITHDRAWAL
            </Button>
          </Flexed>
        </Box>
      )}
    </>
  );
};
